import React from 'react';
// styles
import styled from 'styled-components';

const ChevronTopIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Chevron top"
    className={className}
    role="img"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.98385 3.12155C1.54118 2.66315 0.810719 2.6504 0.352318 3.09307C-0.106082 3.53574 -0.118832 4.26621 0.32384 4.72461L5.13301 9.70465C5.19712 9.77103 5.26772 9.82841 5.34305 9.87645C5.80095 10.2045 6.44152 10.1567 6.84442 9.73944L11.6536 4.7594C12.0963 4.301 12.0835 3.57053 11.6251 3.12786C11.1667 2.68519 10.4362 2.69794 9.99358 3.15634L6.00551 7.2861L1.98385 3.12155Z"
      fill="#94A6B8"
    />
  </svg>
);

export default styled(ChevronTopIcon)`
  transform: rotate(180deg);
`;
